import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import {
  errorToaster,
  successToaster,
} from "../../../../helper/toasterConfiguration";
import StatusChangeModal from "./status-change-modal";
import { useDispatch } from "react-redux";
import { setOpen } from "../../../../Redux/ModalReducer";

const StatusChanger = ({
  setOrderOption,
  source = "service",
  data,
  setData,
  rowsPerPage,
  currentPage,
}) => {
  const dispatch = useDispatch();
  const [isChangeStatusLoading, setIsChangeStatusLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [newStatus, setNewStatus] = useState();

  const handleOpen = () => {
    setShow(true);
    dispatch(setOpen(true));
  };

  const handleClose = () => {
    setShow(false);
    dispatch(setOpen(false));
  };

  const handleRowStatusChange = async (id, newStatus) => {
    setIsChangeStatusLoading(true);
    const { response, message } = await Helper.Post({
      url: `${api_Routes.Orders.Edit}${id}`,
      data: { status: newStatus },
      hasToken: true,
    });

    if (response) {
      // Fetch updated data in the background without affecting `isLoading`
      const url =
        source === "service"
          ? `${api_Routes.Orders.View}?per_page=${rowsPerPage}&page=${
              currentPage + 1
            }`
          : `${api_Routes.Orders.ViewByOffers}?per_page=${rowsPerPage}&page=${
              currentPage + 1
            }`;
      const { response: updatedData } = await Helper.Get({
        url: url,
        hasToken: true,
      });

      if (updatedData) {
        setData(updatedData);
        setOrderOption(source);
      }
      successToaster("The status update was successful");
    } else {
      errorToaster(message || "Failed to update the status");
    }
    handleClose();
    setIsChangeStatusLoading(false);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        position: "relative",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <FormControl size="small" className="w-40">
          <Select
            value={data?.status}
            onChange={(e) => {
              handleOpen();
              setNewStatus(e.target.value);
            }}
            sx={{
              borderRadius: "20px", // Rounded corners
              height: "30px", // Smaller height
              fontSize: "0.875rem", // Smaller font size
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none", // Remove default border
              },
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center", // Center text vertically
                justifyContent: "center", // Center text horizontally
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    justifyContent: "center", // Center dropdown items horizontally
                  },
                },
              },
            }}
            className={`badge w-24 text-darkTextColor ${
              data?.status === "active"
                ? "bg-[#28a745]"
                : data?.status === "pending" || data?.status === "in_progress"
                ? "bg-[#f7cb73]"
                : data?.status === "complete"
                ? "bg-[#114787]"
                : data?.status === "new_request"
                ? "bg-[#800080]"
                : "bg-[#ff6877]"
            }`}
          >
            <MenuItem value="active">
              {isChangeStatusLoading ? (
                <CircularProgress size={18} sx={{ color: "white" }} />
              ) : (
                "Active"
              )}
            </MenuItem>
            <MenuItem value="pending">
              {isChangeStatusLoading ? (
                <CircularProgress size={18} sx={{ color: "white" }} />
              ) : (
                "Pending"
              )}
            </MenuItem>
            <MenuItem value="complete">
              {isChangeStatusLoading ? (
                <CircularProgress size={18} sx={{ color: "white" }} />
              ) : (
                "Complete"
              )}
            </MenuItem>
            <MenuItem value="in_progress">
              {isChangeStatusLoading ? (
                <CircularProgress size={18} sx={{ color: "white" }} />
              ) : (
                "In Progress"
              )}
            </MenuItem>
            <MenuItem value="new_request">
              {isChangeStatusLoading ? (
                <CircularProgress size={18} sx={{ color: "white" }} />
              ) : (
                "New Request"
              )}
            </MenuItem>
            <MenuItem value="cancel">
              {isChangeStatusLoading ? (
                <CircularProgress size={18} sx={{ color: "white" }} />
              ) : (
                "Cancel"
              )}
            </MenuItem>
          </Select>
        </FormControl>
        <StatusChangeModal
          show={show}
          handleClose={handleClose}
          handleSubmit={handleRowStatusChange}
          isLoading={isChangeStatusLoading}
          data={data}
          newStatus={newStatus}
        />
      </div>
    </div>
  );
};

export default StatusChanger;
